<section>

    <form [formGroup]="filterForm" class="container-filter">
        <mat-form-field>
            <mat-label>Buscar</mat-label>
            <input matInput formControlName="search" type="text">
        </mat-form-field>
    </form>

    <div class="cardWithShadow table-section">
        <h2 style="font-weight:500;">Factoring - Cesionarios</h2>
        <ng-container *ngIf="{pagedCesionarios: pagedCesionarios$ | async, error: pagedCesionariosError$ | async} as data">
            <ng-container *ngIf="data.pagedCesionarios as pagedCesionarios; else loading">
                <app-formula-cesionario-table
                [cesionarios]="pagedCesionarios.results"
                [page]="cesionarioParams.page"
                [pageSize]="cesionarioParams.pageSize"
                [totalRows]="pagedCesionarios.totalRows"
                [sortColumn]="cesionarioParams.sortColumn"
                [sortDirection]="cesionarioParams.sortOrder"
                (sorting)="receiveChangeSortingCesionarios($event)"
                (paging)="receiveChangePaginationCesionarios($event)">
                </app-formula-cesionario-table>    
            </ng-container>
            <ng-template #loading>
                <div *ngIf="!data.error" class="spinner-section">
                    <mat-spinner diameter="70"></mat-spinner>
                </div>
                <div *ngIf="data.error" class="error-section">
                    <i-tabler class="icon" name="circle-x"></i-tabler>
                    <span>
                        {{data.error.error.resultMessage || 'Ha ocurrido un error al cargar los datos'}}                        
                    </span>
                </div>
            </ng-template>
        </ng-container>
    </div>
</section>